import { Box, Text } from '@chakra-ui/react';

import BlurredCell from '../../BlurredCell';

interface ProfileNameProps {
  firstName: string;
  lastName: string;
  isTrialUser?: boolean;
  encryptedLastName?: string;
  userKey?: string;
  onBlurHover?: () => void;
}

const noop = () => undefined;

export const ProfileName = ({
  firstName,
  lastName,
  isTrialUser = false,
  encryptedLastName,
  userKey,
  onBlurHover,
}: ProfileNameProps) => {
  return (
    <Text color="lightBlue.600" fontWeight="semibold" fontSize="sm">
      <span data-testid="card-first-name">{firstName}</span>{' '}
      {isTrialUser && lastName.trim().length > 0 ? (
        <Box display="inline-block">
          <BlurredCell
            value={lastName}
            encryptedValue={encryptedLastName}
            onMouseEnter={onBlurHover ?? noop}
            allowUnblur={false}
            isCompact={false}
            userKey={userKey}
            fieldKey="last_name"
            data-testid="card-last-name"
          />
        </Box>
      ) : (
        <span data-testid="card-last-name">{lastName}</span>
      )}
    </Text>
  );
};
